import SideBar from './styled';

export default SideBar;
